import { render, staticRenderFns } from "./CampaignEmail.vue?vue&type=template&id=5a9a5682&scoped=true&"
import script from "./CampaignEmail.vue?vue&type=script&lang=js&"
export * from "./CampaignEmail.vue?vue&type=script&lang=js&"
import style0 from "./CampaignEmail.vue?vue&type=style&index=0&id=5a9a5682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a5682",
  null
  
)

export default component.exports